import React, { createContext, useContext } from "react";

/**
 * Context for sharing track location state and handlers in Crew App
 * Reduces prop drilling through TrackLocation component and its children
 */
const TrackLocationContext = createContext(null);

export const useTrackLocationContext = () => {
  const context = useContext(TrackLocationContext);
  if (!context) {
    throw new Error("useTrackLocationContext must be used within TrackLocationProvider");
  }
  return context;
};

export const TrackLocationProvider = ({ children, value }) => {
  return (
    <TrackLocationContext.Provider value={value}>
      {children}
    </TrackLocationContext.Provider>
  );
};

